export default {
  validateCredentials: 'Otestovať prihlasovacie údaje',
  credentialsInvalidMessage: 'Používateľské meno alebo heslo je nesprávne.',
  credentialsValidMessage: 'Zadané prihlasovacie údaje sú platné',
};
